/**
 * Angular Imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { REACTION_TYPE } from 'src/app/constants/app.constants';

/**
 * View list of the users who watched the contents.
 */
@Component({
  selector: 'app-user-views-list',
  templateUrl: './user-views-list.component.html',
  styleUrls: ['./user-views-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserViewsListComponent implements OnInit {


  /**
   * List of view users.
   * Total view count.
   * Total reactions.
   */
  @Input() viewCard = [];
  @Input() viewCount;
  @Input() reactionCount;

  @Input() viewListByDefault = false;

  @Input() ReactionsText: string;
  @Input() ViewsText: string;

  @Input() viewDetailText: string;

  @Input() viewLessText: string;
  

  /**
   * Emit API request.
   */
  @Output() emitRequest: EventEmitter<void> = new EventEmitter();
  /**
   * Emit scroll event .
   */
  @Output() ScrollEvent: EventEmitter<void> = new EventEmitter();
  /**
   * emit view clicked
   */
  @Output() viewListClicked: EventEmitter<boolean> = new EventEmitter();

  /**
   * Is list in expand mode flag.
   */
  @Input() isListExpanded = false;
  /**
   * flicker value
   */
  @Input() flickerValue: number;

  /**
   * Toggle the expand list.
   */
  toggleList(): void {
    this.isListExpanded = !this.isListExpanded;
    this.viewListClicked.emit(this.isListExpanded);
  }

  /**
   * Necessary instances.
   */
  trackByFn(index: any, item: any): any {
    return item;
  }
  /**
   * on scroll
   */
  onScroll(): void {
    this.ScrollEvent.emit();
  }
  /**
   * get reaction image
   */
  getSrc(type): string {
    console.log(type);
    if (type === REACTION_TYPE.CELEBRATE) {
      return 'assets/images/congo-story.png';
    }
    else if (type === REACTION_TYPE.LIKE) {
      return 'assets/images/like-story.png';
    }
    else if (type === REACTION_TYPE.LOVE) {
      return 'assets/images/heart-story.png';
    }
    else if (type === REACTION_TYPE.SUPPORT) {
      return 'assets/images/heart-hand.png';
    }
    else if (type === REACTION_TYPE.THINK) {
      return 'assets/images/guess-story.png';
    }
  }
  /**
   * Emit API request outside.
   */
  sendRequest(): void {
    this.emitRequest.emit();
  }

  ngOnInit(): void {
    if (this.viewListByDefault) {
      this.toggleList();
    }
  }
}
